module.exports = __webpack_public_path__ + "img/fallback-slide-notext.2560x1280.7ebedbdc.png";